import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";

type Props = {
	hotelID: string;
	planName: string;
};

export const InnerHeader = ({ hotelID, planName }: Props) => {
	return (
		<div className="text-sm">
			<div className="space-y-2">
				<p>・{planName} を予約したゲストに送付されるメールの文言と、送る / 送らないを設定できます</p>
				<p>
					・このページでの設定は
					<Button type="button" className="h-0 px-2" variant="link">
						<a
							className="gap-x-2 break-all text-link-400"
							href={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.TOP, { hotelID })}
						>
							基本メール設定
						</a>
					</Button>
					を上書きします。このページの「送る/送らない」の設定を踏まえて、文面を編集したメールが
					{planName}を予約したゲストに送付されます
				</p>
			</div>
		</div>
	);
};

InnerHeader.displayName = "InnerHeader";
